import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateLoadFormAction } from '../_state/loadForm.state';
import { LoadFormState, LoadRecord } from '../types/load';

type Props = {
  load: LoadRecord | LoadFormState | null | undefined;
};

export const usePopulateLoadForm = ({ load }: Props) => {
  const populateForm = useSetAtom($populateLoadFormAction);

  // Populate form with existing load data
  React.useEffect(() => {
    populateForm(load);
  }, [load, populateForm]);
};
